import React, { Component, Fragment } from 'react';
import ModalT1 from "./Modal";
import Classnames from 'classnames';
import Moment from 'moment';

class HistoryPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {
    const { isModalPopupOpen, handleModalPopupClose, poData, historyData } = this.props;
        return (
            <Fragment>
                <ModalT1 
                    isOpenState={isModalPopupOpen}
                    handleOnClickForClose={handleModalPopupClose}>
                        <div className={Classnames('raw-modal pv-10 ph-10')}>
                            <div className={'fs-20 fSemibold'}>History Details</div>
                            <div className="fs-16 fSemibold mt-20 flex">
                                <div className={'wt-200'}>PO Number : <span style={{'color': '#597EF7'}}>{poData.po_number}</span></div> 
                                <div className={'wt-200'}>Item Number : <span style={{'color': '#597EF7'}}>{((poData.partDetails || {}).part_number)}</span></div> 
                            </div>
                               
                                <div className={'rmTable mt-10'}>
                                    <table width={'100%'} cellSpacing={0} border={1}>
                                       
                                        <tr>
                                            <th className={'pv-5'}>User Name</th>
                                            <th className={'pv-5'}>Event</th>
                                            <th className={'pv-5'}>Updated On</th>
                                        </tr>
                                        {(historyData || []).map((el, mIndex) => { 
                                            return(
                                            <tr>
                                                <td className={'tCenter pv-5'}>{el.user_name}</td>
                                                <td className={'tCenter pv-5'}>{el.poMessage}</td>
                                                <td className={'tCenter pv-5'}>{el.created && Moment(el.created).format('DD/MM/YYYY hh:mm a')}</td>
                                            </tr> )})}
                                    </table>
                                </div>
                            </div>
                </ModalT1>
            </Fragment>
        )
    }
}

export default HistoryPopup;